








import {defineComponent, PropType} from '@vue/composition-api';
import {IImage} from '../../models/image';

import ImageAtom from '@/shared/components/atoms/ImageAtom.vue'
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: 'ImageComponent',
  components: {
    ImageAtom
  },
  props: {
    asset: {
      type: Object as PropType<IImage>,
      required: true
    }
  },
  setup: () => {
    const {imageFallback} = useGetters(['imageFallback'])

    return {
      imageFallback
    }
  }
})
